<div>
  <app-video-small-rect></app-video-small-rect>
</div>